import React from "react";

export const eng = {
    buttons: {
        login: 'Log In',
        register: 'Register',
        logout: 'Log Out',
        signin: 'Log In',
        signup: 'Sign Up',
        confirm: 'Confirm',
        cancel: 'Cancel',
        resetSkills: 'Reset skills',
        save: 'Save',
        setName: 'Set name',
        resetItems: 'Reset items',
        resetTitle: 'Reset title',
        resetDegree: 'Reset degree',
        resetSkillsShort: 'Skills',
        viewStats: 'View stats',
        weapons: 'Weapons',
        armors: 'Armors',
        professions: 'Professions',
        magic: 'Magic',
        other: 'Other',
        castles: 'Castles',
        lightSwords: 'Light',
        semiSworder: 'Semi',
        heavySwords: 'Heavy',
        axes: 'Axes',
        hammers: 'Hammers',
        lightCrossbows: 'Light',
        heavyCrossbows: 'Heavy',
        helmets: 'Helmets',
        cuirasses: 'Cuirasses',
        shields: 'Shields',
        gloves: 'Gloves',
        belts: 'Belts',
        pants: 'Pants',
        rings: 'Rings',
        crystalMA: 'Magical defence crystal',
        crystalPA: 'Physical defence crystal',
        crystalMD: 'Magical attack crystal',
        crystalPD: 'Physical attack crystal',
        boots: 'Boots',
        greenRobe: 'Green',
        whiteRobe: 'White',
        blueRobe: 'Blue',
        redRobe: 'Red',
        amulets: 'Amulets',
        bracers: 'Bracers',
        titleRings: 'Title rings',
        degreeRings: 'Degree rings',
        assassin: 'Assassin',
        barbarian: 'Barbarian',
        blacksmith: 'Blacksmith',
        thief: 'Thief',
        archmage: 'Archmage',
        druid: 'Druid',
        inquisitor: 'Inquisitor',
        necromancer: 'Necromancer',
        sorcerer: 'Sorcerer',
        bandier: 'Bandier',
        crusader: 'Crusader',
        steelMaster: 'Steel master',
        armorer: 'Armorer',
        hunter: 'Hunter',
        radiantMantras: 'Radiant',
        direMantras: 'Dire',
        earthPowder: 'Earth',
        airPowder: 'Air',
        waterPowder: 'Water',
        firePowder: 'Fire',
        crystals: 'Crystals',
        premium: 'Premium',
        eventItems: 'Event items',
        radiantUseless: 'Radiant',
        direUseless: 'Dire',
        private: 'Private',
        public: 'Public',
        noPrefix: 'No prefix',
        yourDolls: 'Your',
        otherDolls: 'Other',
        tableList: 'Tables',
        clans: 'Clans',
        users: 'Users',
        createTable: 'Create',
        table: 'Table',
        doll: 'Doll',
        sortedByLvl: 'Level',
        sortedByTime: 'Time',
        chosen: 'Favorites',
        calculator: 'Calculator',
        add: 'Add',
        kick: 'Kick',
        ban: 'Ban',
        banned: 'Banned',
        chat: 'Chat',
        recipes: 'Recipes',
        maps: 'Maps',
        worldMap: 'World map',
        selectAll: 'Select all',
        unsetAll: 'Unset all',
        dolls: 'Dolls',
        tables: 'Tables',
        home: 'Home',
        stats: 'Stats',
        elixir: 'Elixir',
        defaultDolls: 'Default',
        send: 'Send',
        visible: 'Visible',
        invisible: 'Invisible',
        utils: 'Utils',
        compare: 'Compare',
        items: 'Items',
        description: 'Description'
    },
    texts: {
        registerIs: 'Registration',
        registerFor: ' is only needed for saving and loading your dolls and tables, and also for sending messages in chat',
        dollWithName: 'Doll with name ',
        alreadyExists: ' already exist. Do you want to overwrite current ',
        doll: ' doll?',
        saveDoll: 'Do you want to save your doll as ',
        dollsName: 'Doll\'s name:',
        extraSlots: 'Extra slots',
        reset: 'Reset:',
        login: 'Login',
        register: 'Register',
        hello: 'Hello, ',
        yourDolls: 'Your dolls',
        swords: 'Swords',
        heavyWeapons: 'Heavy weapons',
        crossbows: 'Crossbows',
        armors: 'Armors',
        robes: 'Robes',
        jewerly: 'Jewerly',
        multy: 'Multy',
        title: 'Title',
        degree: 'Degree',
        sets: 'Sets',
        mantras: 'Mantras',
        powder: 'Powder',
        castleItems: 'Castle items',
        other: 'Other',
        noDollsYet: 'No dolls yet...',
        noTablesYet: 'No tables yet...',
        firstTime: 'There\'s a first time for everything!',
        otherMantras: 'Other mantras',
        changeName: 'Change doll\'s name:',
        newName: 'New doll\'s name: ',
        deleteDoll: 'Are you sure you want to delete your ',
        deleteOther: 'Do you want to delete doll ',
        deleteOtherFromList: ' from this list?',
        copied: 'Copied',
        level: 'Level',
        name: 'Name',
        time: 'Time',
        date: 'Date',
        dateOf: 'Filled',
        fillDate: 'Date',
        status: 'Status',
        fillingLevel: 'Elixir',
        sphereTime: 'ST',
        clan: 'Clan',
        commentary: 'Commentary',
        editor: 'Editor',
        yourTables: 'Your tables',
        toAttack: 'Red',
        localTime: 'Local time',
        moscowTime: 'Moscow time',
        sortedBy: 'Sorted by ',
        red: 'Red',
        white: 'White',
        yellow: 'Yellow',
        blue: 'Blue',
        action: 'Action',
        fillingCalculator: 'Filling calculator',
        fillingTable: 'Filling table',
        wantToChange: 'Do you want to change ',
        roleTo: '\'s role to ',
        wantToKick: 'Are you sure you want to kick ',
        fromTable: ' from this table? Person can return using enter link',
        wantToBan: 'Are you sure you want to ban ',
        fromTableBan: ' from this table? Person is not able to see this table unless it gets unbanned',
        noProfession: 'No profession',
        websiteMade: 'Website made by',
        listIsEmpty: 'List is empty',
        wantToDelete: 'Are you sure you want to delete ',
        willBeDeleted: '? It will be deleted for everyone',
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        community: 'Discord',
        youtube: 'YouTube',
        castle: 'Castle',
        recipes: 'Recipes',
        cook: 'Cook in the',
        consumption: 'Consumption',
        class: 'Class',
        active: 'Active',
        multiplier: 'Multiplier',
        cookingIn: 'Cooking in the ',
        furnace: 'furnace',
        cauldron: 'cauldron',
        maps: 'Maps',
        hyperion: 'Hyperion',
        charon: 'Charon',
        rhodes: 'Rhodes',
        leon: 'Leon Island',
        ov: 'Island of Choice',
        phoebus: 'Phoebus',
        pvpDifference: 'PVP difference',
        chosenRecipes: 'Chosen recipes',
        noChosenRecipesYet: 'No chosen recipes yet',
        nickname: 'Nickname',
        noMessages: 'No messages',
        down: 'Down',
        chooseDoll: 'Choose a doll',
        mainChat: 'Public chat',
        enterMessage: 'Enter your message...',
        connecting: 'Connecting...',
        table: 'Table',
        chooseTable: 'Choose table',
        moscowTimeShort: 'Moscow',
        utils: 'Utils',
        utilsDolls: 'Сomparison of dolls',
        utilsElixirs: 'Elixir duration calculator and table',
        utilsExp: 'Experience calculator',
        utilsDollsBody: <div className="utils-doll__description">
            <div>Don't guess - compare!</div>
            <div>This section will allow you to:</div>
            <div className="utils-doll__description-list">
                <div>- <b>Compare</b> the HP, Physical, and Magical defense of two dolls</div>
                <div>- <b>Calculate</b> the exact minimum, average, and maximum damage that characters will inflict on
                    each other using the in-game damage formula
                </div>
                <div>- <b>Determine</b> the number of hits and time required to neutralize an opponent, as well as the
                    chance of victory
                </div>
            </div>
            <i>Make an informed choice and bring benefit to your clan!</i>
        </div>,
        utilsCastleCalcBody: <div className="utils-doll__description">
            <div>Don't let your castle fall!</div>
            <div>This section will help you:</div>
            <div className="utils-doll__description-list">
                <div>- <b>Find out</b>, how long each "filling" level protects a castle of a different level</div>
                <div>- <b>Calculate</b> the exact time when your castle will become "yellow", "red", and when you need
                    to "fill" it to avoid losing protection
                </div>
                <div>- <b>Plan</b> the defense of your castle or the attack on an enemy castle with pinpoint accuracy
                </div>
            </div>
            <i>Act proactively and protect your possessions!</i>
        </div>,
        utilsExpBody: <div className="utils-doll__description">
            <div>Plan your path to the top!</div>
            <div>This section will help you:</div>
            <div className="utils-doll__description-list">
                <div>- <b>Calculate</b> the exact amount of experience needed to level up a character from one set of
                    levels to another.
                </div>
                <div>- <b>Find out</b> how much total experience you will accumulate by any title and degree level.
                </div>
                <div>- <b>Plan</b> your path to new achievements, knowing exactly the resources required.</div>
            </div>
            <i>Reach new heights wisely!</i>
        </div>,
        utilsOverlayBody: <div className="utils-doll__description">
            <div>Always be one step ahead!</div>
            <div>This overlay will help you:</div>
            <div className="utils-doll__description-list">
                <div>- <b>Track</b> the state of locks and their status in real time.</div>
                <div>- <b>Receive</b> data only about the most important locks.</div>
                <div>- <b>Make</b> fast and accurate decisions to capture or defend holdings without leaving the game.</div>
            </div>
            <i>Control every moment on the battlefield!</i>
        </div>,
        charNumber: 'Characters',
        expUtil: 'Exp calculator',
        dollUtil: 'Dolls comparison',
        elixirUtil: 'Calculator and table of elixirs',
        pd: 'PDmg',
        md: 'MDmg',
        pa: 'PArmor',
        ma: 'MArmor',
        hp: 'HP',
        stats: 'Stats',
        damage: 'Damage',
        timeToKill: 'Time to kill',
        hitsToKill: 'Hits to kill',
        summary: 'Summary',
        chanceToWin: 'Chance to win',
        min: 'Min',
        avg: 'Avg',
        max: 'Max',
        oneShotChance: 'Oneshot chance',
        welcome: 'Welcome!',
        actionBlue: 'Filled',
        actionYellow: 'Yellow',
        actionRed: 'Red',
        tableOverlay: 'Table overlay',
        tableOverlayAttention: <div>
            <span className="text-secondary"><b>Attention</b></span>: The program requires a version no lower than v1.2 to work.
        </div>,
        tableOverlayCopyToken: <div>Copy the token to log into the program:</div>,
        tableOverlayDownload: <div className="utils-overlay__overlay-row">
            <div>
                Download the overlay from GitHub:
            </div>
            <a target="_blank" rel="noreferrer" href="https://github.com/HUSH-dreams/SphereTableOverlay/releases/download/v2.3/SphereTableOverlay-v2.3.rar">SphereTableOverlay-v2.3.rar</a>
        </div>,
        tableOverlayGithub: <div className="utils-overlay__overlay-row column">
            <div>
                View the project on GitHub:
            </div>
            <div>
                <a target="_blank" rel="noreferrer" href="https://github.com/HUSH-dreams/SphereTableOverlay">https://github.com/HUSH-dreams/SphereTableOverlay</a>
            </div>
        </div>,
        tableOverlayCheckDotnet: 'Check for .NET 8',
        tableOverlayUtils: 'Utilities',
        tableOverlayDotnetDesc: <div className="utils-overlay__overlay-row--desc">
            To check for the necessary environment, you need to do the following:
            <ul>
                <li>Press&nbsp;<span>Win+R</span></li>
                <li>Type&nbsp;<span>cmd</span>&nbsp;and press&nbsp;<span>OK</span></li>
                <li>Paste the command&nbsp;<span>dotnet --list-runtimes</span>&nbsp;and press&nbsp;<span>Enter</span>&nbsp;</li>
            </ul>
            If the output includes lines about Microsoft.AspNetCore.App, Microsoft.NETCore.App, and Microsoft.WindowsDesktop.App
            with a version of 8.0.x or higher, then the lightweight version of the overlay will work for you.
        </div>,
        tableOverlayLightVersion: 'Light version',
        tableOverlayFullVersion: 'Standalone version',
        tableOverlayRequired: '.NET 8.0 Desktop Runtime is required',
        tableOverlayForFullscreen: <div>
            If you want the game, which is open in full-screen mode,
            to not minimize when working with the overlay, simply add the two files from the archive to the game folder.
            They change the game's display mode from full-screen to borderless windowed mode.

            <div className="utils-overlay__overlay-row--margin-top"><i>In case any issues with the game arise, simply delete files d3d9.ini and d3d9.dll from the game folder.</i></div>
        </div>,
        tableOverlayDescription: <div className="utils-overlay__overlay-info">
            <h3>About the Overlay</h3>
            <p>SphereTableOverlay is a convenient overlay application for Windows designed to help players
                stay up-to-date on castle information without leaving the game.</p>
            <h4>What is it?</h4>
            <p>
                The overlay is a transparent window with a table that you can place over your game client.
                The application allows you to set the exact size and position on the screen.
                This gives you the ability to see the most important castle information in real time without switching windows.
            </p>
            <h4>How does it work?</h4>
            <ul>
                <li><span>Site-like authorization:</span> The overlay offers authorization in the application just like on this website -
                    using a login and password or with a special token that you can copy above.
                </li>
                <li><span>Table selection:</span> After successfully logging in, the overlay prompts you to choose the table from which
                    you will receive data.
                </li>
                <li><span>Automatic updates:</span> The data in the table updates automatically with any changes
                    to the table.
                </li>
                <li><span>Filter:</span> A filter with castle levels at the top of the table allows you to select which castles will be tracked.
                </li>
                <li><span>Saving settings:</span> Upon exiting the application, the following settings are automatically saved:
                    size, screen position, background, castle filter, and selected table.
                </li>
                <li><span>Filling the table:</span> After clicking on a castle, you can update its information in the table.
                </li>
            </ul>
        </div>,
        homeContainerGreeting: <div className="home-container__title"><b>Welcome&nbsp;</b> to the &nbsp;<b>Sphere: The World of Chosen&nbsp;</b> game website!</div>,
        homeContainerFind: <div className="home-container__title text-secondary bold">Here you will find:</div>,
        homeContainerDoll: <div>A character doll constructor with the ability to save and send to other users</div>,
        homeContainerTable: <div>A table for filling in information about castle levels with the ability to add users</div>,
        homeContainerRecipes: <div>A list of recipes for brewing powders with the ability to save to favorites</div>,
        homeContainerMaps: <div>Maps of the World and individual continents with the exact location of objects and the ability to select layers</div>,
        homeContainerStats: <div>A comparison of PVP statistics for selected dates. The statistics are updated every day at 12:00 PM Moscow time</div>,
        homeContainerUtils: <div>A utility for detailed comparison of various doll parameters, an experience calculator, and a level calculator with a table,
            as well as an overlay program to access the table</div>,
        homeContainerHomePage: 'Home page',
        homeContainerChangeLog: <div className="home-container__change-list">
            <div className="home-container__title text-secondary bold">Change Log:</div>
            <div className="home-container__change-body">
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">05.10.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.15</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Overlay</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Added a new version of the program - v2.5. Fixed bugs with castle sorting. Added sorting by castle level.
                    </div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Doll</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Fixed/added some animations.
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">28.09.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.14</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Overlay</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Added a new version of the program - v2.4. "Comment" and "Filling" columns have been added to the table. Also added the ability to minimize the application content and set/unset all castles.
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">09.09.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.13</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Table</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Added current time autofill in the castle editing window.
                    </div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Overlay</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Added a new version of the program - v2.3. Removed the display of unnecessary interface elements, and the current time is now set in the castle editing window.
                    </div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Website</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Fixed bug with guest counter
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">08.09.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.12</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Table</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Added the ability to select your clan. To do this, click on your clan's name in the table's list of clans.
                    </div>
                    <div className="home-container__change-text-row">
                        The status field has been moved to the left side of the table.
                    </div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Overlay</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Added a new version of the program - v2.2. It now includes "Decay" (time until decay) and "Clan" columns, as well as the ability to change the column order.
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">07.09.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.11</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Overlay</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Added a new version of the program - v2.1. The new version includes an initial loading indicator and fixes the overlay's display over the game.
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Calculator</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Fixed a bug with level order.
                        </div>
                        <div className="home-container__change-text-row">
                            Changed the position of the calculator's close button in the table.
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">01.09.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.10</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Doll</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Expanded the list of castle items for 15-45 castles.
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Website</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Translated all main content of the website to english.
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">31.08.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.9</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Doll</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Castle items are now grouped by individual castles and have the correct prefix.
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">30.08.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.8</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Overlay</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Added a new version of the program - v2.0. In the new version, you can fill in information about castles.
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Table</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Changed the site's behavior if a table was selected. Now, changes made by another user will be visible in any section of the site. Also, when switching from another section to the table page, you won't have to re-select the table.
                        </div>
                        <div className="home-container__change-text-row">
                            Improved table display on narrow screens.
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">29.08.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.7</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Overlay</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Added a new version of the program - v1.2.
                        </div>
                        <div className="home-container__change-text-row">
                            Added mobile styles for the overlay section.
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Table</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Reworked the table's interaction with the server - now all actions in the table (adding/removing clans, users, changing castle data) are immediately visible to all online users without requiring a reload.
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">27.08.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.6</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Overlay</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Added a new utility - an overlay program that allows you to access the table on top of the game window without an open browser.
                        </div>
                        <div className="home-container__change-text-row">
                            Added a link to the new overlay version.
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">24.08.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.5</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Doll</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Added armor and jewelry sets to the item list.
                        </div>
                        <div className="home-container__change-text-row">
                            Minor visual improvements.
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Website</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Fixed minor bugs.
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">23.08.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.4</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Statistics</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Added the ability to view castle statistics and clan PVP.
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Chat</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            On mobile devices, the chat is now always on the right side.
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Improvements</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Minor visual improvements.
                        </div>
                        <div className="home-container__change-text-row">
                            Changed the style of the level calculator and PVP difference.
                        </div>
                        <div className="home-container__change-text-row">
                            Mobile optimization.
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">22.08.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.3</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Menu</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            The menu on mobile devices is no longer constantly visible but is available via a button.
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Maps</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Added the Isle of Choice map.
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">22.08.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.2</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Experience Calculator</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Added a new utility - the experience calculator. The calculator provides information on how much experience is needed to level up a character from and to specific levels.
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Maps</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Added the map of Leon Island (castle Il-Suilly-Rua).
                        </div>
                        <div className="home-container__change-text-row">
                            Added spawn icons for Elemental Demons on Hyperion.
                        </div>
                        <div className="home-container__change-text-row">
                            Fixed a bug with displaced icons on maps.
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Statistics</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            In the statistics section, double arrows have been added, allowing you to rewind statistics a month forward or backward.
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Doll Comparison</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Corrected the damage formula.
                        </div>
                    </div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Added the ability to compare other users' and standard dolls.
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Chat</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Fixed a bug with the message order in the chat on some devices.
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">20.08.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.1</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Utilities</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Added styles for medium and small screens.
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">20.08.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.0</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Doll Comparison</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Added a new utility - "Doll Comparison." This utility allows for a detailed comparison of two dolls to find out how much time and how many hits are needed to kill, what damage the character can inflict, and what the chance of winning is.
                        </div>
                    </div>
                    <div className="home-container__change-section"><b className="text-secondary">Utilities</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            A new section on the site. Currently, it includes the "Doll Comparison" and "Level Calculator" utilities.
                        </div>
                    </div>
                    <div className="home-container__change-section"><b className="text-secondary">Doll</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Removed unnecessary empty item containers.
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">23.07.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v5.6</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Table</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Fixed an issue with the castle edit window closing when clicking on it.
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">21.07.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v5.5</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Account</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            A visibility toggle (default - visible) has been added to the side menu. The toggle affects the display of the nickname in the list of online users.
                        </div>
                    </div>
                    <div className="home-container__change-section"><b className="text-secondary">Table</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Fixed a bug with multiple castle edit windows opening.
                        </div>
                    </div>
                    <div className="home-container__change-section"><b className="text-secondary">Recipes</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Changed the order of professions.
                        </div>
                    </div>
                    <div className="home-container__change-section"><b className="text-secondary">Improvements</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Minor improvements to element display and animations.
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">20.07.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v5.4</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Improvements</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Minor visual improvements.
                        </div>
                    </div>
                    <div className="home-container__change-section"><b className="text-secondary">Table</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Changed the table display on mobile devices - now only the most important table fields are shown.
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">19.07.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v5.3</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Improvements</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Reworked page navigation logic on mobile devices: now, when you navigate to another page, the page content itself appears instead of the side menu. The same behavior has been added for selecting a doll or a table.
                        </div>
                        <div className="home-container__change-text-row">
                            Minor visual improvements.
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Fixes</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Fixed the mechanism for loading the selected doll.
                        </div>
                        <div className="home-container__change-text-row">
                            Fixed site display issues for Mozilla Firefox and Safari browsers.
                        </div>
                        <div className="home-container__change-text-row">
                            Fixed a bug with empty notifications being displayed.
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">18.07.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v5.2</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Statistics</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Added a clans column to the PVP difference window.
                        </div>
                        <div className="home-container__change-text-row">
                            Changed statistics styles on mobile devices.
                        </div>
                    </div>
                    <div className="home-container__change-section"><b className="text-secondary">Table</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Changed the appearance of the page when no table is selected.
                        </div>
                        <div className="home-container__change-text-row">
                            The level calculator is now available without selecting a table.
                        </div>
                    </div>
                    <div className="home-container__change-section"><b className="text-secondary">Fixes</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Fixed minor display bugs.
                        </div>
                        <div className="home-container__change-text-row">
                            Fixed a bug with the 8th additional slot in the doll.
                        </div>
                        <div className="home-container__change-text-row">
                            Added the ability for unauthorized users to select a standard doll.
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">17.07.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v5.1</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Doll</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Added a list of standard dolls to the left side menu.
                        </div>
                        <div className="home-container__change-text-row">
                            Added filtering of dolls by profession.
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Statistics</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Changed the location of statistics when entering the page. Now, the statistics for the most "recent" date are on the right, and for the previous date on the left.
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Table</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            You can no longer open the castle edit window if the list of clans in the table is empty - a pop-up notification has been added.
                        </div>
                        <div className="home-container__change-text-row">
                            "Favorites" is now the default list of castles in the table.
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Recipes</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            The list of favorite recipes is now visible to unauthorized users as well.
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Chat</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Removed chat scrolling to the last message when navigating between pages.
                        </div>
                    </div>
                </div>
            </div>
        </div>,
        homeContainerNewSections: <i>* Other sections may be added in the future</i>,
        homeContainerOnline: 'Currently online:',
        homeContainerGuests: 'Guests:',
        utilsExpStartLvl: 'Starting level',
        utilsExpEndLvl: 'Ending level',
        utilsExpRequired: 'Required experience',
        utilsExpDescription: <div className="util-exp__desc">
            <p>The calculator estimates the minimum experience needed to reach the specified levels.</p>
            <p>Proper leveling assumes that a character's title and level degree will never differ by more than one, or that they will strive towards this.</p>
            <p>Example: leveling up from 10/20 to 50/40. The calculator first equalizes the levels (resulting in 20/20), then levels up to 40/40 (20/21, 21/21, 21/22, etc.), and only then levels up the title to 50.</p>
        </div>
    }, errors: {
        email: 'Invalid email',
        passwordRegex: 'Minimum eight characters, at least one uppercase letter, one lowercase letter and one digit',
        confirmPassword: 'Confirm password doesn\'t match password',
        nickname: 'Nickname length must be between 4 and 24 symbols'
    }, inputs: {
        email: 'Email',
        nickname: 'Nickname',
        password: 'Password',
        confirmPassword: 'Confirm password',
        name: 'Name',
        newTable: 'Best clan\'s table...'
    }, selects: {
        select1: 'Ordinary',
        select2: 'Great',
        select3: 'Greatest',
        select4: 'Legendary',
        today: 'Today',
        yesterday: 'Yesterday',
        twoDaysAgo: 'Two days ago',
        tomorrow: 'Tomorrow',
        earlier: 'Earlier',
        moderator: 'Moderator',
        viewer: 'Viewer',
    },
}